export default __webpack_public_path__ + "static/media/pexels-axecop-2697608.7f84382a.jpg";